<script>

import formatISO from 'date-fns/formatISO'
import addDays from 'date-fns/addDays'

export default {
  methods: {
    formattedDate(transactionDate) {
      if (transactionDate === this.toISO(new Date())) return this.$t('WalletTransactionDetailsPage.today')
      if (transactionDate === this.toISO(addDays(new Date(), -1))) return this.$t('WalletTransactionDetailsPage.yesterday')
      return this.$d(transactionDate)
    },
    toISO(date) {
      return formatISO(date, { representation: 'date' })
    }
  }
}
</script>
